import { Routes, Route } from 'react-router-dom';

import HomePage from '../pages/HomePage';
import PricingPage from '../pages/PricingPage';
import ContactUsPage from '../pages/ContactUsPage';
import SignInPage from '../pages/SignInPage';
import SignUpPage from '../pages/SignUpPage';
import InviteSignUpPage from '../pages/InviteSignUpPage';

import ProfilePage from '../pages/internal/ProfilePage';
import DashboardPage from '../pages/internal/DashboardPage';
import ConsumerDashboardPage from '../pages/internal/ConsumerDashboardPage';
import ProjectPage from '../pages/internal/ProjectPage';
import ProjectDetailsPage from '../pages/internal/ProjectDetailsPage';
import SignOutPage from '../pages/internal/SignOutPage';


import NotFoundPage from '../pages/NotFoundPage';

const PublicRoutes = () => (
    <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/invite-signup" element={<InviteSignUpPage />} />

        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/project/:projectId" element={<ProjectDetailsPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/consumer-dashboard" element={<ConsumerDashboardPage />} />
        <Route path="/project" element={<ProjectPage />} />
        <Route path="/signout" element={<SignOutPage />} />

        <Route path="*" element={<NotFoundPage />} />
    </Routes>
);

export default PublicRoutes;